import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import FeedbackForm from "./FeedbackForm"; // Import the FeedbackForm component

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<FeedbackForm />} /> {/* Form route */}
      </Routes>
    </Router>
  );  
}

export default App;
